import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAppSelector } from "../hooks";
import { RootState } from "../redux/store";
import { UserRole } from "../interfaces";
import { useAuthenticateQuery } from "../redux/auth/auth.api";
import { useGetMemberAccessQuery } from "@/redux/app/access.api";
import useSidebar, { flattenSidebarLeaves } from "@/hooks/useSidebar";

export const PrivateRoute = () => {
  useAuthenticateQuery();
  const isAuthenticated = useAppSelector((state: RootState) => !!state.auth.loggedIn);
  const { role } = useAppSelector((state) => state.auth.user);
  const { data } = useGetMemberAccessQuery({ role });
  const sidebar = useSidebar();

  const location = useLocation();
  const pathname = location.pathname;

  const leaves = flattenSidebarLeaves(sidebar);
  const moduleItem = leaves
    .filter((value) => pathname === value.path || pathname.startsWith(`${value.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];

  // inventory-statement is part of Inventory module but not a sidebar leaf.
  const module =
    moduleItem?.module ??
    (pathname.startsWith("/inventory")
      ? leaves.find((l) => l.path === "/inventory")?.module
      : undefined);

  const isPermitted = data?.entries.find((d) => d.module === module)?.read;

  if (isAuthenticated) {
    if (module && isPermitted === false) {
      return <Navigate to="/access-denied" />;
    }

    return <Outlet />;
  }

  return <Navigate to="/" />;
};

interface IProtectedRoute {
  roles: UserRole[];
}

export const ProtectedRoute = ({ roles }: IProtectedRoute) => {
  const { role } = useAppSelector((state) => state.auth.user);

  return roles.includes(role as UserRole) ? <Outlet /> : <Navigate to="/" />;
};
